import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Pagination from '@material-ui/lab/Pagination';
import React, { Fragment, useEffect, useState } from "react";

// css
import '../../common.css';
import './CustomerBalance.css';

// components
import ReactLoading from 'react-loading';
import Navbar from '../../navbar';
import TableTemplate from '../../table-template';

// sample data (temp)
import { Navigate, useParams } from "react-router-dom";
import { getBalance } from "../../../utilities/api_calls/customerBalanceAPI";
import NoDataPrompt from '../../../utilities/no-data-prompt';

function CustomerBalance() {
  const { from, page } = useParams();
  const mainPage = '/customer-balance'
  const [redirect, setRedirect] = useState(false);
  const [showLoader, setShowLoader] = useState(false);
  const [balanceReport, setBalanceReport] = useState([])
  const [customerID, setCustomerID] = useState("");
  const [customerName, setCustomerName] = useState("");
  const [filter, setFilter] = useState({
    name: '',
    page: 1,
  });
  

  // Pagination
  const [pages, setPages] = useState(1);
  const [currentPage, setCurrentPage] = useState(1);

  function handlePageChange(event, value) {
    setFilter((prev) => ({
      ...prev,
      page: value,
    }))
    setCurrentPage(value)
  }

  async function fetchBalance() {
    setShowLoader(true);
    const response = await getBalance({...filter, name: customerName});
    if(response.data){
      let num_pages = Math.ceil(response.data.data.size / 10);
      setPages(num_pages);
      setBalanceReport(response.data.data.data);
    } else {
      setPages(1);
      setBalanceReport([]);
    }
    setShowLoader(false);
  };

  const handleKeyPress = (event) => {
    if (event.key === 'Enter') {
      setCurrentPage(1)
      setFilter((prev) => ({
        ...prev,
        page: 1,
      }))
    }
  };

  useEffect(() => {
    fetchBalance()
  }, [filter])

  function view(id) {
    setCustomerID(id)
    setRedirect(true);
  }

  if (redirect === true) {
    if (from === "0") {
      return ( // customer balance
        <Navigate to={mainPage + "/details/0/" + page + "/" + customerID} />
      )
    } else if (from === "1") {
      return ( // balance report
        <Navigate to={"/balance-report/details/1/" + page + "/" + customerID} />
      )
    }
  }

  function renderTable() {
    if (balanceReport.length === 0) {
      return (
        <NoDataPrompt text="customer balance" />
      )
    } else {
      return (
        <>
          <TableTemplate
            tableType='balance'
            tableHeaders={["Customer Name", "Total Balance", ""]}
            tableData={balanceReport}
            tableNavgn={[view]}
            currentPage={currentPage}
          />
          <Pagination 
            count={pages} 
            page={currentPage} 
            shape="rounded" 
            defaultPage={1} 
            siblingCount={2} 
            onChange={handlePageChange} 
            showFirstButton 
            showLastButton 
          />
        </>
      )
    }
  }

  // --- Render --- //

  return (
    <>
      <div>
        <Navbar />
        <div className="active-cont">
          <Fragment>

            <div className="d-flex flex-row justify-content-between cont-section">
              <h1 className="cont-sect-header">Customer Balance</h1>
                <div className="search-wrapper w-50">
                  <input 
                    type="search" 
                    className="form-control search-indent" 
                    name="search" 
                    value={customerName} 
                    onChange={(e) => setCustomerName(e.target.value)} 
                    onKeyDown={handleKeyPress}
                    placeholder="Search by Customer Name" 
                  />
                  <div className="search-icon">
                    <FontAwesomeIcon
                      className="icon"
                      icon={'search'}
                      aria-hidden="true"
                      alt={'search'}
                      fixedWidth
                      onClick={fetchBalance}
                    />
                  </div>
                </div>
            </div>

            <div className="customer-balance-table mx-4">
              {
                showLoader ?
                  <ReactLoading 
                    type="spinningBubbles" 
                    color="#d4271c" 
                    height={200} 
                    width={100} 
                    className='list-loader' 
                  />
                : 
                  renderTable()
              }
            </div>

          </Fragment>

        </div>
      </div>
    </>
  )
}

export default CustomerBalance;